import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "superior" }
const _hoisted_3 = { class: "header-flex" }
const _hoisted_4 = {
  key: 0,
  class: "ctx-strip"
}
const _hoisted_5 = {
  key: 0,
  class: "ctx-version"
}
const _hoisted_6 = {
  key: 0,
  class: "ctx-ruta-tipo"
}
const _hoisted_7 = {
  key: 1,
  class: "ctx-ruta-ordinal"
}
const _hoisted_8 = { class: "ctx-ruta-nombre" }
const _hoisted_9 = {
  key: 2,
  class: "ctx-ruta-nodo ctx-indicador-row"
}
const _hoisted_10 = { class: "ctx-indicador" }
const _hoisted_11 = { class: "contenedor-tabla" }
const _hoisted_12 = {
  key: 0,
  class: "info"
}
const _hoisted_13 = {
  key: 1,
  class: "lista-tabla"
}
const _hoisted_14 = { class: "doc-celda" }
const _hoisted_15 = {
  key: 0,
  class: "rename-row"
}
const _hoisted_16 = ["onKeyup"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href", "title"]
const _hoisted_20 = {
  key: 1,
  class: "badge-origen externo"
}
const _hoisted_21 = {
  key: 2,
  class: "badge-formato"
}
const _hoisted_22 = {
  key: 2,
  class: "badge-origen desconocido"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { class: "celda-nota" }
const _hoisted_26 = { class: "nota-chip" }
const _hoisted_27 = { class: "nota-metodo" }
const _hoisted_28 = {
  key: 1,
  class: "nota-chip nota-chip--vacia"
}
const _hoisted_29 = { class: "acciones-ficha" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["disabled", "onChange"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 2,
  class: "panel-calculo"
}
const _hoisted_36 = { class: "pc-cab" }
const _hoisted_37 = { class: "pc-metodo" }
const _hoisted_38 = {
  key: 0,
  class: "tabla-periodos"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 1,
  class: "sin-periodos"
}
const _hoisted_41 = {
  key: 2,
  class: "nuevo-periodo"
}
const _hoisted_42 = ["value"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 3,
  class: "nota-cuantitativa"
}
const _hoisted_45 = { class: "nc-cab" }
const _hoisted_46 = { class: "nc-valor" }
const _hoisted_47 = { class: "nc-lbl" }
const _hoisted_48 = {
  key: 0,
  class: "nc-aviso"
}
const _hoisted_49 = {
  key: 1,
  class: "nc-aviso"
}
const _hoisted_50 = {
  key: 1,
  class: "nc-sin"
}
const _hoisted_51 = {
  key: 3,
  class: "mensaje-vacio"
}
const _hoisted_52 = { class: "fila" }
const _hoisted_53 = { class: "toggle-group" }
const _hoisted_54 = { class: "toggle-label" }
const _hoisted_55 = { class: "toggle-label" }
const _hoisted_56 = { class: "fila" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "fila" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "hint"
}
const _hoisted_63 = { class: "fila" }
const _hoisted_64 = ["required", "disabled"]
const _hoisted_65 = { class: "fila" }
const _hoisted_66 = ["required", "disabled"]
const _hoisted_67 = {
  key: 0,
  class: "fila"
}
const _hoisted_68 = {
  key: 1,
  class: "fila fila-doble"
}
const _hoisted_69 = {
  key: 2,
  class: "fila"
}
const _hoisted_70 = {
  key: 0,
  class: "tabla-periodos"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 1,
  class: "sin-periodos"
}
const _hoisted_73 = { class: "nuevo-periodo" }
const _hoisted_74 = ["onKeyup"]
const _hoisted_75 = ["value"]
const _hoisted_76 = ["disabled"]
const _hoisted_77 = {
  key: 3,
  class: "nota-cuantitativa nota-previa"
}
const _hoisted_78 = { class: "nc-cab" }
const _hoisted_79 = { class: "nc-valor" }
const _hoisted_80 = { class: "nc-lbl" }
const _hoisted_81 = {
  key: 0,
  class: "nc-aviso"
}
const _hoisted_82 = {
  key: 1,
  class: "nc-sin"
}
const _hoisted_83 = { class: "fila" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { class: "fila" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { class: "botones" }

import { onMounted, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGestionFichas } from '@/store/GestionFichas'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useModelo } from '@/store/GestionModelo'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import type { Ficha } from '@/interfaces/Ficha'
import {
  getPeriodosService,
  crearPeriodoService,
  eliminarPeriodoService,
  getEtiquetasValoracionService,
  simularNotaCuantitativaService
} from '@/services/FichasService'
import type {
  ValoracionPeriodo,
  EtiquetaValoracion,
  NotaCuantitativa,
  PeriodoNuevo
} from '@/services/FichasService'

interface RutaNodo { tipo: string; ordinal: string; nombre: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'FichaEstadistica',
  props: {
    idInstrumento: { default: null },
    nombreVersion: {},
    rutaComponente: {},
    nombreIndicador: {}
  },
  emits: ["cerrar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Ficha de evidencia cuantitativa.
 *
 * Dos métodos de cálculo: por periodos o directo (logro/meta). La nota la
 * recalcula el backend en cada cambio, así que tras editar hay que releerla.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ficha-estadistica` (FichaEstadistica) — permiso `evidencias.subir`
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props
const emit = __emit

const fichaStore = useGestionFichas()
const versionesStore = useGestionVersiones()
const modeloStore = useModelo()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const subiendo = ref<number | null>(null)
const renombrandoId = ref<number | null>(null)
const fichasRecienCreadas = ref<number[]>([])
const nuevoNombre = ref('')

function iniciarRenombrar(f: Ficha) {
  renombrandoId.value = f.id_ficha!
  nuevoNombre.value = f.nombre_visible ?? f.nombre_documento ?? ''
}

function cancelarRename() {
  renombrandoId.value = null
  nuevoNombre.value = ''
}

async function guardarNombre(idFicha: number) {
  const nombre = nuevoNombre.value.trim()
  if (!nombre) { cancelarRename(); return }
  const resultado = await fichaStore.actualizarFicha(idFicha, { nombre_documento: nombre })
  if (resultado) {
    mostrarMensaje('Nombre actualizado', 'positivo')
    await cargarFichas()
  } else {
    mostrarMensaje('Error al actualizar el nombre', 'error')
  }
  cancelarRename()
}
const archivoSeleccionado = ref<File | null>(null)
const fileInputRef = ref<HTMLInputElement | null>(null)

const fichasLocales = ref<Ficha[]>([])

const fichasUnicas = computed(() => {
  const vistas = new Set<number>()
  return fichasLocales.value.filter(f => {
    if (!f.id_ficha || vistas.has(f.id_ficha)) return false
    vistas.add(f.id_ficha)
    return true
  })
})


const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const formData = ref<Omit<Ficha, 'id_ficha' | 'tipo'> & {
  metodo_calculo?: string | null
  logro?: number | null
  meta?: number | null
}>({
  id_instrumento: 0,
  estado: 'existe',
  documento: '',
  fuente_datos: '',
  escala_cuantitativa: '',
  metodo_calculo: null,
  logro: null,
  meta: null,
  detalle: '',
  observaciones: '',
  fecha_registro: new Date().toISOString().split('T')[0]
})

// ── Cálculo de la nota ───────────────────────────────────────────────
/** Ficha cuyo panel de cálculo está abierto. */
const fichaCalculando = ref<number | null>(null)
const periodos = ref<ValoracionPeriodo[]>([])
const etiquetas = ref<EtiquetaValoracion[]>([])
const notaCalculada = ref<NotaCuantitativa | null>(null)
const nuevoPeriodo = ref({ periodo: '', valoracion: '' })

// Periodos de la ficha que TODAVÍA no existe: se acumulan en el formulario y
// viajan en el mismo POST que la ficha.
const periodosNuevos = ref<PeriodoNuevo[]>([])
const periodoEnEdicion = ref<PeriodoNuevo>({ periodo: '', valoracion: '' })
const notaPrevia = ref<NotaCuantitativa | null>(null)
/** Escala del modelo; la simulación la necesita para dar la nota correcta. */
const escalaMaxModelo = ref<number>(5)

function puntosDe(valoracion: string): number | null {
  return etiquetas.value.find(e => e.valoracion === valoracion)?.puntos ?? null
}

function etiquetaMetodo(metodo?: string | null): string {
  if (metodo === 'por_periodos') return 'por periodos'
  if (metodo === 'directo') return 'logro/meta'
  return ''
}

function agregarPeriodoNuevo() {
  const { periodo, valoracion } = periodoEnEdicion.value
  if (!periodo || !valoracion) return
  periodosNuevos.value.push({ periodo, valoracion })
  periodoEnEdicion.value = { periodo: '', valoracion: '' }
}

function quitarPeriodoNuevo(indice: number) {
  periodosNuevos.value.splice(indice, 1)
}

/**
 * Pide al backend la nota que dará el cálculo tal como está.
 *
 * El cálculo NO se replica aquí: la nota que se muestra mientras se llena el
 * formulario y la que se guarda al confirmar salen del mismo servicio.
 */
async function refrescarNotaPrevia() {
  const metodo = formData.value.metodo_calculo
  if (metodo !== 'por_periodos' && metodo !== 'directo') {
    notaPrevia.value = null
    return
  }
  if (metodo === 'por_periodos' && !periodosNuevos.value.length) {
    notaPrevia.value = null
    return
  }
  if (metodo === 'directo' && (formData.value.logro == null || formData.value.meta == null)) {
    notaPrevia.value = null
    return
  }

  notaPrevia.value = await simularNotaCuantitativaService({
    metodo_calculo: metodo,
    logro: formData.value.logro ?? null,
    meta: formData.value.meta ?? null,
    escala_max: escalaMaxModelo.value,
    periodos: periodosNuevos.value
  })
}

watch(
  () => [formData.value.metodo_calculo, formData.value.logro, formData.value.meta, periodosNuevos.value.length],
  () => { refrescarNotaPrevia() }
)

// Método de la ficha abierta en el panel, editable sin salir de él.
const metodoDelPanel = ref<string | null>(null)
const logroDelPanel = ref<number | null>(null)
const metaDelPanel = ref<number | null>(null)

async function abrirCalculo(idFicha: number) {
  fichaCalculando.value = idFicha
  nuevoPeriodo.value = { periodo: '', valoracion: '' }
  await cargarCalculo()
}

function cerrarCalculo() {
  fichaCalculando.value = null
  periodos.value = []
  notaCalculada.value = null
  metodoDelPanel.value = null
}

async function cargarCalculo() {
  const id = fichaCalculando.value
  if (!id) return
  const datos = await getPeriodosService(id)
  if (!datos) return
  periodos.value = datos.periodos
  if (datos.etiquetas?.length) etiquetas.value = datos.etiquetas
  notaCalculada.value = datos.nota_sugerida
  metodoDelPanel.value = datos.metodo_calculo
  logroDelPanel.value = datos.logro
  metaDelPanel.value = datos.meta
}

/** Guarda el método en la ficha existente y refresca su nota. */
async function guardarMetodoDelPanel() {
  const id = fichaCalculando.value
  if (!id) return

  const actualizada = await fichaStore.actualizarFicha(id, {
    metodo_calculo: metodoDelPanel.value as Ficha['metodo_calculo'],
    logro: metodoDelPanel.value === 'directo' ? logroDelPanel.value : null,
    meta: metodoDelPanel.value === 'directo' ? metaDelPanel.value : null
  })

  if (!actualizada) {
    mostrarMensaje('No se pudo guardar el método de cálculo', 'error')
    return
  }
  await cargarCalculo()
  await cargarFichas()
}

async function agregarPeriodo() {
  const id = fichaCalculando.value
  if (!id) return
  if (await crearPeriodoService(id, { ...nuevoPeriodo.value })) {
    nuevoPeriodo.value = { periodo: '', valoracion: '' }
    await cargarCalculo()
  }
}

async function quitarPeriodo(idValoracion: number) {
  if (await eliminarPeriodoService(idValoracion)) await cargarCalculo()
}

// Control de confirmación y toast
const showConfirmacion = ref(false)
const tituloConfirmacion = ref('')
const mensajeConfirmacion = ref('')
let accionPendiente: (() => Promise<void>) | null = null

function parseInstrumentoId(input: unknown): number | null {
  if (input === null || input === undefined) return null
  const raw = Array.isArray(input) ? input[0] : input
  const value = typeof raw === 'string' ? Number(raw) : typeof raw === 'number' ? raw : Number(String(raw))
  return Number.isFinite(value) && value > 0 ? value : null
}

async function cargarFichas() {
  const id = parseInstrumentoId(
    props.idInstrumento ??
    (route.query as any).id_instrumento ??
    (route.params as any).id_instrumento ??
    (route.params as any).id
  )
  if (!id) {
    mostrarMensaje('No se encontró id_instrumento en la URL.', 'error')
    return
  }

  formData.value.id_instrumento = id
  loading.value = true
  try {
    fichasLocales.value = (await fichaStore.listarFichas({ id_instrumento: id, tipo: 'estadistica' })) ?? []
  } finally {
    loading.value = false
  }
}

async function cargarEscalaModelo() {
  const rawVersion = route.params.id_version ?? route.query.id_version
  const idVersion = Number(Array.isArray(rawVersion) ? rawVersion[0] : rawVersion)
  if (!Number.isFinite(idVersion) || idVersion <= 0) return
  try {
    const version = await versionesStore.getVersionById(idVersion)
    const idModelo = (version as any)?.id_modelo
    if (!idModelo) return
    const modelo = await modeloStore.getModeloById(idModelo)
    const escalaMax = modelo?.escala_max
    if (!escalaMax) return
    escalaMaxModelo.value = escalaMax
    const texto = escalaMax > 5 ? `1 - ${escalaMax}` : `0 - ${escalaMax}`
    if (!formData.value.escala_cuantitativa?.trim()) {
      formData.value.escala_cuantitativa = texto
    }
  } catch { /* noop */ }
}

onMounted(async () => {
  cargarFichas()
  cargarEscalaModelo()
  // Las valoraciones se cargan de entrada: el formulario tiene que ofrecerlas
  // sin que exista todavía ninguna ficha.
  etiquetas.value = await getEtiquetasValoracionService()
})

watch(() => props.idInstrumento, (val) => {
  if (val != null) cargarFichas()
})

async function guardarFicha() {
  if (!formData.value.id_instrumento || formData.value.id_instrumento <= 0) {
    mostrarMensaje('id_instrumento es requerido para crear la ficha.', 'error')
    return
  }

  if (!formData.value.estado) {
    mostrarMensaje('Por favor seleccione un estado', 'error')
    return
  }

  if (formData.value.estado !== 'no_existe') {
    if (!formData.value.fuente_datos?.trim()) {
      mostrarMensaje('Fuente de datos es requerida', 'error')
      return
    }
    if (!formData.value.escala_cuantitativa?.trim()) {
      mostrarMensaje('Escala cuantitativa es requerida', 'error')
      return
    }
  }

  tituloConfirmacion.value = 'Guardar Ficha Estadística'
  mensajeConfirmacion.value = '¿Está seguro de que desea guardar esta ficha?'
  
  accionPendiente = async () => {
    const docValue = archivoSeleccionado.value
      ? 'pendiente-upload'
      : (formData.value.documento || 'sin-documento')

    const noExiste = formData.value.estado === 'no_existe'
    const porPeriodos = formData.value.metodo_calculo === 'por_periodos'
    const payload: Omit<Ficha, 'id_ficha'> = {
      ...formData.value,
      documento: docValue,
      tipo: 'estadistica',
      // Los periodos van en la misma petición que la ficha: así nace con su
      // nota calculada y no hace falta un segundo paso.
      ...(porPeriodos && periodosNuevos.value.length ? { periodos: periodosNuevos.value } : {}),
      ...(noExiste ? { fuente_datos: 'Ninguna', escala_cuantitativa: '0' } : {})
    }

    const resultado = await fichaStore.crearFicha(payload)

    if (resultado.ok && resultado.ficha) {
      if (resultado.ficha.id_ficha) fichasRecienCreadas.value.push(resultado.ficha.id_ficha)
      if (archivoSeleccionado.value && resultado.ficha.id_ficha) {
        mostrarMensaje('Ficha creada. Subiendo archivo...', 'positivo')
        const uploadResult = await fichaStore.uploadArchivo(resultado.ficha.id_ficha, archivoSeleccionado.value)
        if (uploadResult.ok) {
          mostrarMensaje('Ficha guardada y archivo subido exitosamente', 'positivo')
        } else {
          mostrarMensaje(uploadResult.error || 'Ficha creada pero error al subir archivo', 'error')
        }
      } else {
        mostrarMensaje('Ficha estadística guardada exitosamente', 'positivo')
      }
      archivoSeleccionado.value = null
      limpiarFormulario()
      cargarEscalaModelo()
      await cargarFichas()
    } else {
      mostrarMensaje(resultado.error || 'Error al guardar la ficha', 'error')
    }
  }

  showConfirmacion.value = true
}

function limpiarFormulario() {
  formData.value = {
    id_instrumento: 0,
    estado: 'existe',
    documento: '',
    fuente_datos: '',
    escala_cuantitativa: '',
    // Se reinician explícitamente: al omitirlos, el método y los datos de
    // cálculo de una ficha se arrastraban a la siguiente.
    metodo_calculo: null,
    logro: null,
    meta: null,
    detalle: '',
    observaciones: '',
    fecha_registro: new Date().toISOString().split('T')[0]
  }
  periodosNuevos.value = []
  periodoEnEdicion.value = { periodo: '', valoracion: '' }
  notaPrevia.value = null
}

function abrirConfirmacionEliminar(id: number | undefined) {
  if (!id) return

  tituloConfirmacion.value = 'Eliminar Ficha'
  mensajeConfirmacion.value = '¿Está seguro de que desea eliminar esta ficha? Esta acción no se puede deshacer.'
  
  accionPendiente = async () => {
    const resultado = await fichaStore.eliminarFicha(id)
    
    if (resultado) {
      mostrarMensaje('Ficha eliminada exitosamente', 'positivo')
      await cargarFichas()
    } else {
      mostrarMensaje('Error al eliminar la ficha', 'error')
    }
  }

  showConfirmacion.value = true
}

function confirmarAccion() {
  showConfirmacion.value = false
  if (accionPendiente) {
    accionPendiente()
    accionPendiente = null
  }
}

function cancelarAccion() {
  showConfirmacion.value = false
  accionPendiente = null
}

function onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (file) archivoSeleccionado.value = file
}

function quitarArchivo() {
  archivoSeleccionado.value = null
  if (fileInputRef.value) fileInputRef.value.value = ''
}

function reutilizarFicha(f: Ficha) {
  archivoSeleccionado.value = null
  if (fileInputRef.value) fileInputRef.value.value = ''
  formData.value = {
    id_instrumento: formData.value.id_instrumento,
    estado: f.estado ?? '',
    documento: (f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
      ? f.documento
      : '',
    fuente_datos: f.fuente_datos ?? '',
    escala_cuantitativa: f.escala_cuantitativa ?? '',
    detalle: f.detalle ?? '',
    observaciones: f.observaciones ?? '',
    descripcion: f.descripcion ?? '',
    fecha_registro: new Date().toISOString().split('T')[0]
  }
  document.querySelector<HTMLElement>('.ficha-form')?.scrollIntoView({ behavior: 'smooth' })
}

async function subirArchivo(idFicha: number, event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file || !idFicha) return

  subiendo.value = idFicha
  try {
    const result = await fichaStore.uploadArchivo(idFicha, file)
    if (result.ok) {
      mostrarMensaje('Archivo subido exitosamente', 'positivo')
    } else {
      mostrarMensaje(result.error || 'Error al subir archivo', 'error')
    }
    await cargarFichas()
  } finally {
    subiendo.value = null
    input.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "titulo-ficha" }, "Ficha Estadística", -1)),
        _createElementVNode("button", {
          class: "btn salir",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.idInstrumento != null ? emit('cerrar') : _unref(router).back()))
        }, _toDisplayString(_ctx.idInstrumento != null ? 'Cerrar' : 'Volver'), 1)
      ]),
      (_ctx.nombreVersion || _ctx.rutaComponente?.length || _ctx.nombreIndicador)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.nombreVersion)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.nombreVersion), 1))
              : _createCommentVNode("", true),
            (_ctx.rutaComponente?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.rutaComponente, (nodo, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "ctx-ruta-nodo"
                  }, [
                    (nodo.tipo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(nodo.tipo), 1))
                      : _createCommentVNode("", true),
                    (nodo.ordinal)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nodo.ordinal), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(nodo.nombre), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.nombreIndicador)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "ctx-ruta-tipo" }, "Indicador", -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.nombreIndicador), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_11, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Cargando fichas estadísticas..."))
        : (fichasUnicas.value.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
              _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "NO."),
                  _createElementVNode("th", null, "ESTADO"),
                  _createElementVNode("th", null, "DOCUMENTO"),
                  _createElementVNode("th", null, "ESCALA"),
                  _createElementVNode("th", null, "FUENTE"),
                  _createElementVNode("th", null, "NOTA"),
                  _createElementVNode("th", null, "ACCIÓN")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fichasUnicas.value, (f, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: f.id_ficha
                  }, [
                    _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['badge', `badge-${f.estado}`])
                      }, _toDisplayString(f.estado), 3)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      (renombrandoId.value === f.id_ficha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nuevoNombre).value = $event)),
                              class: "input-nombre",
                              onKeyup: [
                                _withKeys(($event: any) => (guardarNombre(f.id_ficha!)), ["enter"]),
                                _withKeys(cancelarRename, ["escape"])
                              ],
                              placeholder: "Nombre del documento"
                            }, null, 40, _hoisted_16), [
                              [_vModelText, nuevoNombre.value]
                            ]),
                            _createElementVNode("button", {
                              class: "btn guardar btn-sm-accion",
                              onClick: ($event: any) => (guardarNombre(f.id_ficha!))
                            }, "OK", 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "btn salir btn-sm-accion",
                              onClick: cancelarRename
                            }, "✕")
                          ]))
                        : (f.origen_documento === 'cloudinary' || f.origen_documento === 'externo')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("a", {
                                href: f.documento,
                                target: "_blank",
                                rel: "noopener",
                                class: "link-doc"
                              }, _toDisplayString(f.nombre_visible || 'Ver documento'), 9, _hoisted_18),
                              (f.url_descarga && f.origen_documento === 'cloudinary')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: f.url_descarga,
                                    class: "link-descargar",
                                    title: `Descargar ${f.nombre_visible || 'archivo'}`
                                  }, "⬇", 8, _hoisted_19))
                                : _createCommentVNode("", true),
                              (f.origen_documento === 'externo')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "externo"))
                                : _createCommentVNode("", true),
                              (f.formato)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(f.formato.toUpperCase()), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (f.origen_documento === 'desconocido')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "No disponible"))
                            : (!f.origen_documento && f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  href: f.documento,
                                  target: "_blank",
                                  rel: "noopener",
                                  class: "link-doc"
                                }, "Ver documento", 8, _hoisted_23))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(f.escala_cuantitativa), 1),
                    _createElementVNode("td", null, _toDisplayString(f.fuente_datos), 1),
                    _createElementVNode("td", _hoisted_25, [
                      (f.calculo?.nota != null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(f.calculo.nota.toFixed(2)), 1),
                            _createElementVNode("small", _hoisted_27, _toDisplayString(etiquetaMetodo(f.metodo_calculo)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      (!fichasRecienCreadas.value.includes(f.id_ficha!))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn guardar btn-sm-accion",
                            onClick: ($event: any) => (reutilizarFicha(f))
                          }, "Reutilizar", 8, _hoisted_30))
                        : _createCommentVNode("", true),
                      (f.id_ficha && renombrandoId.value !== f.id_ficha && f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn guardar btn-sm-accion",
                            onClick: ($event: any) => (iniciarRenombrar(f))
                          }, "Renombrar", 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", {
                        class: _normalizeClass(["btn guardar btn-upload", { disabled: subiendo.value === f.id_ficha }])
                      }, [
                        _createTextVNode(_toDisplayString(subiendo.value === f.id_ficha ? 'Subiendo...' : 'Subir archivo') + " ", 1),
                        _createElementVNode("input", {
                          type: "file",
                          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.txt",
                          hidden: "",
                          disabled: subiendo.value === f.id_ficha,
                          onChange: ($event: any) => (subirArchivo(f.id_ficha!, $event))
                        }, null, 40, _hoisted_32)
                      ], 2),
                      _createElementVNode("button", {
                        class: "btn guardar btn-sm-accion",
                        onClick: ($event: any) => (abrirCalculo(f.id_ficha!))
                      }, "Calcular nota", 8, _hoisted_33),
                      _createElementVNode("button", {
                        class: "btn salir",
                        onClick: ($event: any) => (abrirConfirmacionEliminar(f.id_ficha))
                      }, "Eliminar", 8, _hoisted_34)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
      (fichaCalculando.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("h3", null, "Cálculo de la nota · ficha #" + _toDisplayString(fichaCalculando.value), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn salir btn-sm-accion",
                onClick: cerrarCalculo
              }, "Cerrar")
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[26] || (_cache[26] = _createElementVNode("label", null, "¿Cómo se calcula?", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((metodoDelPanel).value = $event)),
                class: "form-control",
                onChange: guardarMetodoDelPanel
              }, _cache[25] || (_cache[25] = [
                _createElementVNode("option", { value: null }, "— A mano, sin cálculo —", -1),
                _createElementVNode("option", { value: "por_periodos" }, "Por periodos (valorar año por año)", -1),
                _createElementVNode("option", { value: "directo" }, "Directo (logro sobre meta)", -1)
              ]), 544), [
                [_vModelSelect, metodoDelPanel.value]
              ]),
              (metodoDelPanel.value === 'directo')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((logroDelPanel).value = $event)),
                      class: "form-control input-corto",
                      placeholder: "Logro"
                    }, null, 512), [
                      [
                        _vModelText,
                        logroDelPanel.value,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      step: "0.01",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((metaDelPanel).value = $event)),
                      class: "form-control input-corto",
                      placeholder: "Meta"
                    }, null, 512), [
                      [
                        _vModelText,
                        metaDelPanel.value,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn guardar btn-sm-accion",
                      onClick: guardarMetodoDelPanel
                    }, " Guardar ")
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (periodos.value.length && metodoDelPanel.value === 'por_periodos')
              ? (_openBlock(), _createElementBlock("table", _hoisted_38, [
                  _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Periodo"),
                      _createElementVNode("th", null, "Valoración"),
                      _createElementVNode("th", null, "Puntos"),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodos.value, (p) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: p.id_valoracion
                      }, [
                        _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                        _createElementVNode("td", null, _toDisplayString(p.valoracion), 1),
                        _createElementVNode("td", null, _toDisplayString(puntosDe(p.valoracion) ?? '—'), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-quitar",
                            onClick: ($event: any) => (quitarPeriodo(p.id_valoracion))
                          }, "×", 8, _hoisted_39)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (metodoDelPanel.value === 'por_periodos')
                ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Aún no se ha registrado ningún periodo. "))
                : _createCommentVNode("", true),
            (metodoDelPanel.value === 'por_periodos')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((nuevoPeriodo.value.periodo) = $event)),
                    class: "form-control",
                    placeholder: "Año 1"
                  }, null, 512), [
                    [_vModelText, nuevoPeriodo.value.periodo]
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((nuevoPeriodo.value.valoracion) = $event)),
                    class: "form-control"
                  }, [
                    _cache[28] || (_cache[28] = _createElementVNode("option", {
                      value: "",
                      disabled: ""
                    }, "Valoración…", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(etiquetas.value, (e) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: e.valoracion,
                        value: e.valoracion
                      }, _toDisplayString(e.valoracion) + " (" + _toDisplayString(e.puntos) + ") ", 9, _hoisted_42))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, nuevoPeriodo.value.valoracion]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn guardar btn-sm-accion",
                    disabled: !nuevoPeriodo.value.periodo || !nuevoPeriodo.value.valoracion,
                    onClick: agregarPeriodo
                  }, " Agregar ", 8, _hoisted_43)
                ]))
              : _createCommentVNode("", true),
            (notaCalculada.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  (notaCalculada.value.nota != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(notaCalculada.value.nota.toFixed(2)), 1),
                          _createElementVNode("span", _hoisted_47, [
                            _createTextVNode(_toDisplayString(notaCalculada.value.desglose?.porcentaje_cumplimiento?.toFixed(2)) + "% de cumplimiento ", 1),
                            (notaCalculada.value.desglose?.tendencia)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(notaCalculada.value.desglose.tendencia.tendencia), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (notaCalculada.value.desglose?.topado_al_100)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_48, " El cumplimiento real fue " + _toDisplayString(notaCalculada.value.desglose.porcentaje_sin_tope) + "%; superar la meta no da más del máximo, así que se toma 100%. ", 1))
                          : _createCommentVNode("", true),
                        (notaCalculada.value.desglose?.valoraciones_no_reconocidas?.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_49, " No se contaron: " + _toDisplayString(notaCalculada.value.desglose.valoraciones_no_reconocidas.join(', ')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(notaCalculada.value.motivo), 1))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_51, "No hay fichas cuantitativas registradas."))
    ]),
    _createElementVNode("form", {
      class: "ficha-form",
      onSubmit: _withModifiers(guardarFicha, ["prevent"])
    }, [
      _cache[45] || (_cache[45] = _createElementVNode("h3", null, "Nueva Ficha", -1)),
      _createElementVNode("div", _hoisted_52, [
        _cache[31] || (_cache[31] = _createElementVNode("label", null, "¿La Ficha existe? *", -1)),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("label", _hoisted_54, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.estado) = $event)),
              value: "existe",
              required: ""
            }, null, 512), [
              [_vModelRadio, formData.value.estado]
            ]),
            _cache[29] || (_cache[29] = _createTextVNode(" ✓ Existe "))
          ]),
          _createElementVNode("label", _hoisted_55, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.estado) = $event)),
              value: "no_existe",
              required: ""
            }, null, 512), [
              [_vModelRadio, formData.value.estado]
            ]),
            _cache[30] || (_cache[30] = _createTextVNode(" ✗ No existe "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _cache[33] || (_cache[33] = _createElementVNode("label", null, "Subir archivo de evidencia", -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["upload-area", { disabled: formData.value.estado === 'no_existe' }])
        }, [
          _createElementVNode("label", {
            class: _normalizeClass(["upload-label", { disabled: formData.value.estado === 'no_existe' }])
          }, [
            _createElementVNode("input", {
              type: "file",
              ref_key: "fileInputRef",
              ref: fileInputRef,
              accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.txt",
              hidden: "",
              disabled: formData.value.estado === 'no_existe',
              onChange: onFileSelected
            }, null, 40, _hoisted_57),
            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "upload-icon" }, "📎", -1)),
            (archivoSeleccionado.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(archivoSeleccionado.value.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_59, "Seleccionar archivo (PDF, DOC, XLS, IMG, etc.)"))
          ], 2),
          (archivoSeleccionado.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-quitar",
                onClick: quitarArchivo
              }, "Quitar"))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_60, [
        _cache[34] || (_cache[34] = _createElementVNode("label", null, "O enlace del documento", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "url",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.documento) = $event)),
          disabled: formData.value.estado === 'no_existe' || !!archivoSeleccionado.value,
          placeholder: "https://...",
          class: "form-control"
        }, null, 8, _hoisted_61), [
          [_vModelText, formData.value.documento]
        ]),
        (archivoSeleccionado.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_62, "El enlace se generará automáticamente al subir el archivo."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("label", null, "Fuente de datos" + _toDisplayString(formData.value.estado !== 'no_existe' ? ' *' : ''), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.fuente_datos) = $event)),
          required: formData.value.estado !== 'no_existe',
          disabled: formData.value.estado === 'no_existe',
          placeholder: "De dónde provienen los datos",
          class: "form-control"
        }, null, 8, _hoisted_64), [
          [_vModelText, formData.value.fuente_datos]
        ])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("label", null, "Escala cuantitativa" + _toDisplayString(formData.value.estado !== 'no_existe' ? ' *' : ''), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.escala_cuantitativa) = $event)),
          required: formData.value.estado !== 'no_existe',
          disabled: formData.value.estado === 'no_existe',
          placeholder: "Ej: 0-100, 1-5, Porcentaje",
          class: "form-control"
        }, null, 8, _hoisted_66), [
          [_vModelText, formData.value.escala_cuantitativa]
        ])
      ]),
      (formData.value.estado !== 'no_existe')
        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
            _cache[36] || (_cache[36] = _createElementVNode("label", null, [
              _createTextVNode("¿Cómo se calcula la nota? "),
              _createElementVNode("span", { class: "opcional" }, "(opcional)")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.metodo_calculo) = $event)),
              class: "form-control"
            }, _cache[35] || (_cache[35] = [
              _createElementVNode("option", { value: null }, "— A mano, sin cálculo —", -1),
              _createElementVNode("option", { value: "por_periodos" }, "Por periodos (valorar año por año)", -1),
              _createElementVNode("option", { value: "directo" }, "Directo (logro sobre meta)", -1)
            ]), 512), [
              [_vModelSelect, formData.value.metodo_calculo]
            ])
          ]))
        : _createCommentVNode("", true),
      (formData.value.metodo_calculo === 'directo')
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _createElementVNode("div", null, [
              _cache[37] || (_cache[37] = _createElementVNode("label", null, "Logro alcanzado", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.01",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.logro) = $event)),
                class: "form-control",
                placeholder: "120"
              }, null, 512), [
                [
                  _vModelText,
                  formData.value.logro,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[38] || (_cache[38] = _createElementVNode("label", null, "Meta planeada", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                step: "0.01",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.meta) = $event)),
                class: "form-control",
                placeholder: "100"
              }, null, 512), [
                [
                  _vModelText,
                  formData.value.meta,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (formData.value.metodo_calculo === 'por_periodos')
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
            _cache[41] || (_cache[41] = _createElementVNode("label", null, "Periodos a valorar", -1)),
            (periodosNuevos.value.length)
              ? (_openBlock(), _createElementBlock("table", _hoisted_70, [
                  _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Periodo"),
                      _createElementVNode("th", null, "Valoración"),
                      _createElementVNode("th", null, "Puntos"),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodosNuevos.value, (p, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                        _createElementVNode("td", null, _toDisplayString(p.valoracion), 1),
                        _createElementVNode("td", null, _toDisplayString(puntosDe(p.valoracion) ?? '—'), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-quitar",
                            onClick: ($event: any) => (quitarPeriodoNuevo(i))
                          }, "×", 8, _hoisted_71)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_72, "Agrega un periodo por cada año (o semestre) que vayas a valorar.")),
            _createElementVNode("div", _hoisted_73, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((periodoEnEdicion.value.periodo) = $event)),
                class: "form-control",
                placeholder: "2024",
                onKeyup: _withKeys(_withModifiers(agregarPeriodoNuevo, ["prevent"]), ["enter"])
              }, null, 40, _hoisted_74), [
                [_vModelText, periodoEnEdicion.value.periodo]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((periodoEnEdicion.value.valoracion) = $event)),
                class: "form-control"
              }, [
                _cache[40] || (_cache[40] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "Valoración…", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(etiquetas.value, (e) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: e.valoracion,
                    value: e.valoracion
                  }, _toDisplayString(e.valoracion) + " (" + _toDisplayString(e.puntos) + ") ", 9, _hoisted_75))
                }), 128))
              ], 512), [
                [_vModelSelect, periodoEnEdicion.value.valoracion]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn guardar btn-sm-accion",
                disabled: !periodoEnEdicion.value.periodo || !periodoEnEdicion.value.valoracion,
                onClick: agregarPeriodoNuevo
              }, " Agregar ", 8, _hoisted_76)
            ])
          ]))
        : _createCommentVNode("", true),
      (notaPrevia.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            (notaPrevia.value.nota != null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("span", _hoisted_79, _toDisplayString(notaPrevia.value.nota.toFixed(2)), 1),
                    _createElementVNode("span", _hoisted_80, [
                      _createTextVNode(" nota que quedará registrada · " + _toDisplayString(notaPrevia.value.desglose?.porcentaje_cumplimiento?.toFixed(2)) + "% de cumplimiento ", 1),
                      (notaPrevia.value.desglose?.tendencia)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" · " + _toDisplayString(notaPrevia.value.desglose.tendencia.tendencia), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (notaPrevia.value.desglose?.topado_al_100)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_81, " El cumplimiento real fue " + _toDisplayString(notaPrevia.value.desglose.porcentaje_sin_tope) + "%; superar la meta no da más del máximo, así que se toma 100%. ", 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_82, _toDisplayString(notaPrevia.value.motivo), 1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_83, [
        _cache[42] || (_cache[42] = _createElementVNode("label", null, "Detalle de la ficha", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.detalle) = $event)),
          disabled: formData.value.estado === 'no_existe',
          placeholder: "Explicación de los datos estadísticos",
          class: "form-control"
        }, null, 8, _hoisted_84), [
          [_vModelText, formData.value.detalle]
        ])
      ]),
      _createElementVNode("div", _hoisted_85, [
        _cache[43] || (_cache[43] = _createElementVNode("label", null, "Observaciones", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.observaciones) = $event)),
          disabled: formData.value.estado === 'no_existe',
          placeholder: "Notas adicionales",
          class: "form-control"
        }, null, 8, _hoisted_86), [
          [_vModelText, formData.value.observaciones]
        ])
      ]),
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("button", {
          type: "button",
          class: "btn salir",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.idInstrumento != null ? emit('cerrar') : _unref(router).back()))
        }, _toDisplayString(_ctx.idInstrumento != null ? 'Cerrar' : 'Volver'), 1),
        _cache[44] || (_cache[44] = _createElementVNode("button", {
          type: "submit",
          class: "btn guardar"
        }, "Guardar Ficha", -1))
      ])
    ], 32),
    _createVNode(MensajeConfirmacion, {
      visible: showConfirmacion.value,
      title: tituloConfirmacion.value,
      message: mensajeConfirmacion.value,
      confirmText: "Confirmar",
      cancelText: "Cancelar",
      onConfirm: confirmarAccion,
      onCancel: cancelarAccion
    }, null, 8, ["visible", "title", "message"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[20] || (_cache[20] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})